/*ěščřžýáíéúů*/

jQuery(document).ready(function ($) {
    $(".faq-item__header").click(function (e) { 
        e.preventDefault();
        if($(this).parent().hasClass("active")) {
            $(this).parent().removeClass("active");
            $(this).parent().find(".faq-item__content").slideUp();
        }else {
            $(this).parent().addClass("active");
            $(this).parent().find(".faq-item__content").slideDown();
        }
    });

    var $modal = $('#video-modal');
    var $wrap  = $('#video-wrapper');

    function withAutoplay(url, qs) {
        // přidá/rozšíří query string
        return url.replace(/(\?[^#]*)?$/, function (m) {
        return (m ? m + '&' : '?') + qs;
        });
    }

    function buildEmbed(type, url) {
        if (type === 'youtube') {
        var yt = withAutoplay(url, 'autoplay=1&rel=0&playsinline=1');
        return $('<iframe>', {
            src: yt, allow: 'autoplay; encrypted-media; picture-in-picture',
            allowfullscreen: true
        });
        }
        if (type === 'vimeo') {
        var vm = withAutoplay(url, 'autoplay=1&playsinline=1');
        return $('<iframe>', {
            src: vm, allow: 'autoplay; fullscreen; picture-in-picture',
            allowfullscreen: true
        });
        }
        // mp4 fallback
        return $('<video>', {
        src: url, controls: true, autoplay: true, playsinline: true
        });
    }

    $('.video-open').on('click', function (e) {
        e.preventDefault();
        var type = $(this).data('type');
        var url  = $(this).data('url');

        $wrap.empty().append(
        $('<div class="video-aspect"></div>').append( buildEmbed(type, url) )
        );

        // otevři modal
        $modal.modal({
        fadeDuration: 200,
        showClose: true
        });
    });

    // Po zavření modalu zastav přehrávání a vyčisti DOM
    $(document).on($.modal.AFTER_CLOSE, function () {
        // YouTube/Vimeo: zneplatni src, aby se iframe zastavil
        $wrap.find('iframe').attr('src', 'about:blank');
        $wrap.empty();
    });
});


document.addEventListener("DOMContentLoaded", function () {
    const swiper = new Swiper(".swiper-gallery", {
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next-gallery", // Specifičtější selektor
            prevEl: ".swiper-button-prev-gallery",
        },

        slidesPerView: "auto",
        spaceBetween: 20,
    });

    const videoswiper = new Swiper(".swiper-video", { 
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next-video", // Specifičtější selektor
            prevEl: ".swiper-button-prev-video",
        },

        slidesPerView: "auto",
        spaceBetween: 20,
    });

    Fancybox.bind("[data-fancybox='gallery']", {
        // Optional Fancybox settings
        loop: true,
        buttons: ["zoom", "slideShow", "thumbs", "close"],
    });
});

